import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/login/login.service';
import { Principal } from 'src/app/core/auth/principal.service';
import { SnackBarService } from 'src/app/core/services/snackbar.service';
import { ComponentWithLoadingState } from '../component-with-loading-state/component-with-loading-state';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'ctv-change-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordDialogComponent extends ComponentWithLoadingState {
  public readonly email: string;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private readonly snackBarService: SnackBarService,
    private readonly loginService: LoginService,
    private readonly principal: Principal,
  ) {
    super();
    this.email = this.principal.getUser()?.email;
    this.dialogRef.updateSize('520px');
  }

  public sendResetLink() {
    this._loading$.next(true);
    this.loginService.sendChangePasswordEmail(this.email)
      .pipe(
        finalize(() => this._loading$.next(false))
      )
      .subscribe(
        () => {
          this.snackBarService.success('Password reset link sent — check your email.');
          this.dialogRef.close();
        },
        () => {
          this.snackBarService.error('Error while trying to send the password reset link.');
        }
      );
  }
}
